



































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import Car from '@/entities/Car';
import TimeLeft from '@/components/TimeLeft.vue';
import BuyNowButton from '@/components/buttons/BuyNow.vue';
import Purchase from '@/entities/Purchase';
import Bid from '@/entities/Bid';
import Logo from '@/components/svg/Logo.vue';
import BidService from '@/services/bid';
import Variables from '@/config/variables';

@Component({
    components: {
        BuyNowButton,
        TimeLeft,
        Logo,
    },
})
export default class CarTile extends Vue {
    @Prop()
    car: Car;

    @Prop()
    purchase: Purchase;

    @Prop()
    bid: Bid;

    bidService = new BidService();

    variables = new Variables();

    get purchaseCalculations(): any {
        return this.bidService.calculate(this.purchase.amount, this.car);
    }

    get bidCalculations(): any {
        return this.bidService.calculate(this.bid.amount, this.car);
    }

    get carDetailsUrl(): string {
        return `/car/${this.car.id}`;
    }
}
